import React, {useState} from "react";
import BtnSvg from "../../../boiteAOutils/BtnSvg";

const ContextMenu = ({
                         menuPosition,
                         selectedObject,
                         deleteSelectedObject,
                         verrouillerSelectedObject,
                         deverrouillerSelectedObject,
                         copyObject,
                         createPlanningAction
                     }) => {
    const [, setForceUpdate] = useState(0); // État factice pour forcer le re-render
    const selectedItems = selectedObject?.type === "activeSelection" ? selectedObject.getObjects() : [selectedObject];
    const isLocked = selectedItems.every(object => object?.lockMovementX && object?.lockMovementY);

    const handleToggleLock = () => {
        if (isLocked) {
            deverrouillerSelectedObject();
        } else {
            verrouillerSelectedObject();
        }
        setForceUpdate(prev => prev + 1); // Force le re-render
    };

    return (
        <div className="contextMenu" style={{left: `${menuPosition.x}px`, top: `${menuPosition.y}px`}}>
            <div onClick={handleToggleLock} className={"cursor-pointer"}>
                {
                    isLocked ? (
                        <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="2.66699" y="10.25" width="14.6667" height="9.67" fill="#002335" stroke="#002335"
                                  strokeWidth="2"/>
                            <path
                                d="M5.83301 10.168V6.5013C5.83301 5.28573 6.27199 4.11994 7.0534 3.2604C7.8348 2.40085 8.89461 1.91797 9.99967 1.91797C11.1047 1.91797 12.1646 2.40085 12.946 3.2604C13.7274 4.11994 14.1663 5.28573 14.1663 6.5013V10.168"
                                stroke="#002335" strokeWidth="2"/>
                        </svg>
                    ) : (
                        <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="2.66699" y="10.7891" width="14.6667" height="9.67" stroke="#70787B"
                                  strokeWidth="2"/>
                            <path
                                d="M5.83301 8.5V5.16667C5.83301 4.0616 6.27199 3.00179 7.0534 2.22039C7.8348 1.43899 8.89461 1 9.99967 1C11.1047 1 12.1646 1.43899 12.946 2.22039C13.7274 3.00179 14.1663 4.0616 14.1663 5.16667V8.5"
                                stroke="#70787B" strokeWidth="2"/>
                        </svg>
                    )
                }
            </div>

            <div className={"copyBtn"} onClick={() => copyObject()}>Copier</div>

            <button type="button" className="contextActionBtn" onClick={createPlanningAction}>
                Créer une action
            </button>

            <BtnSvg svg={'corbeille'} onClick={deleteSelectedObject}/>
        </div>
    );
};

export default ContextMenu;
